/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CreditLedgerExportRequestDirection = typeof CreditLedgerExportRequestDirection[keyof typeof CreditLedgerExportRequestDirection] | null;


export const CreditLedgerExportRequestDirection = {
  spend: 'spend',
  grant: 'grant',
} as const;
